import { render, staticRenderFns } from "./CommunityFamilyList.vue?vue&type=template&id=8612e21a&scoped=true&"
import script from "./CommunityFamilyList.vue?vue&type=script&lang=js&"
export * from "./CommunityFamilyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8612e21a",
  null
  
)

export default component.exports